// extracted by mini-css-extract-plugin
export default {"cover_img":"ExclusiveTypeSection_cover_img__elvU4"};